import { Spin} from "antd"
import { useEffect, useState } from "react"
import { getPools } from "@/api"
import type { StockPool } from "@/types"
import ModelDialog from "@/components/ModelDialog"
import './index.scss'
import { useFeedback } from "@/utils/antdApp"

export default function ContactPool({ 
    open, 
    defaultStockPoolId,
    onCancel,
    onContactPool
}: { 
    open: boolean, 
    defaultStockPoolId?: number | null,
    onCancel: () => void 
    onContactPool: (poolId: number | null, poolName?: string | null) => void
}) {
    const { message } = useFeedback()
    const [pools, setPools] = useState<StockPool[]>([])
    const [loading, setLoading] = useState(true)
    const [isSelectId, setIsSelectId] = useState<number | null>(null)
    const [selectedPoolName, setSelectedPoolName] = useState<string | null>(null)

    const load = () => getPools().then(data => {
        setPools(data)
        if(defaultStockPoolId) {
            setIsSelectId(defaultStockPoolId)
        }
    }).catch(() => message.error('加载失败')).finally(() => setLoading(false))

    useEffect(() => {
        load()
    }, [defaultStockPoolId])

    const onSelectPool = (pool: StockPool) => {
        if(isSelectId === pool.id) {
            setIsSelectId(null)
            setSelectedPoolName(null)
        } else {
            setIsSelectId(pool.id)
            setSelectedPoolName(pool.name)
        }
    }

    const onLinkPool = () => {
        onContactPool(isSelectId, selectedPoolName)
    }

    return (
        <ModelDialog
            open={open}
            onCancel={onCancel}
            onSure={onLinkPool}
            title='默认股票池'
        >
            {loading ? <div className='page-loading'><Spin /> </div> :
                <div className='contact-pool-content'>
                    <div className='contact-pool-content-list'>
                        {pools.map(pool => (
                            <div key={pool.id} className='contact-pool-content-item flex items-center color-2' onClick={() => onSelectPool(pool)}>
                                <div className={`contact-pool-content-item-dot color-1 ${isSelectId === pool.id ? 'active' : ''}`}>{isSelectId === pool.id?'✓':''}</div>
                                <div className='contact-pool-content-item-title'>{pool.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            }
        </ModelDialog>
    )
}